import { render, staticRenderFns } from "./setInformation.vue?vue&type=template&id=1ab287b5"
import script from "./setInformation.vue?vue&type=script&lang=js"
export * from "./setInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports